import React from 'react';
import {HeaderDetailsBox} from "./boxes/header-details/header-details.box";
import {HeaderMenuIconsBox} from "./boxes/header-menu-icons/header-menu-icons.box";
import {HeaderMenuIconBox} from "./boxes/header-menu-icon/header-menu-icon.box";
import {MiniOrbitHeaderBox} from "./boxes/mini-orbit-header/mini-orbit-header.box";
import {MiniOrbitBalanceComponent} from "../balance/mini-orbit-balance.component";
import {observer} from 'mobx-react';
import {MiniOrbitUsefulLinksListComponent} from '../useful-links/mini-orbit-useful-links-list.component';
import {CurrentArenaTitleBox} from './boxes/current-arena-title/current-arena-title.box';
import {HeaderMenuGiftBox} from "./boxes/gift/header-menu-gift.box";
import {HeaderMenuGiftIndicatorBox} from "./boxes/gift/header-menu-gift-indicator.box";
import {InsideOrbitMenuContainerComponent} from "../../inside-orbit-menu-container/inside-orbit-menu-container.component";
import {CIP8_TITLE} from "./mini-orbit-header.consts";
import {RegulatoryDataComponent} from '../../header/top-header-left/regulatory-data/regulatory-data.component';
import {MiniOrbitNavbarWrapperBox} from "./boxes/mini-orbit-header/mini-orbit-navbar-wrapper.box";
import {CyClass} from "../../../../common/cy-classes";
import {ComponentServicesPick} from "../../../services/component-services-pick";
import {useServices} from "../../../react-hooks/use-services.hook";
import {withServices} from "../../../react-hooks/with-services";

interface MiniOrbitHeaderComponentProps extends ComponentServicesPick<'header'> {
    
}

const ComponentBody: React.FC<MiniOrbitHeaderComponentProps> = observer((props) => {
    const services = useServices();

    const _openUsefulLinks = () => {
        services.dialog.showModal((dialogHandler) => <MiniOrbitUsefulLinksListComponent dialogHandler={dialogHandler}/>, {
            title: services.translation.translate("USEFUL_LINKS"),
            forceTransparentBackground: true,
            useAutoHeight: true
        });
    };

    const _openSearch = async () => {
        await (await services.gameSearch).openSearchResult();
    };

    const _captureMiniHeaderBox = (element: HTMLElement) => {
        props.header.setHeaderElement(element);
    };

    const _renderGiftIndicator = () => {
        if (services.freePlay.hasVouchers){
            return <HeaderMenuGiftIndicatorBox className={CyClass('cy-user-profile-messages-indicator')}/>
        } else {
            return null;
        }

    }

    return (
        <React.Fragment>
            <MiniOrbitHeaderBox className={'cy-mini-orbit-header'}>
                <RegulatoryDataComponent attachToHeaderService={true}/>
                <MiniOrbitNavbarWrapperBox className="cy-mini-orbit-navbar-wrapper" ref={_captureMiniHeaderBox}>
                    <HeaderDetailsBox>
                        <CurrentArenaTitleBox className='cy-current-arena-title'>
                            { services.translation.translate(CIP8_TITLE) }
                        </CurrentArenaTitleBox>
                        <MiniOrbitBalanceComponent />
                    </HeaderDetailsBox>
                    <HeaderMenuIconsBox>
                        <InsideOrbitMenuContainerComponent/>
                        <HeaderMenuIconBox src={services.theme.currentTheme.assets.images.mini_orbit.header_icons.search_png.toString()} onClick={_openSearch} />
                        <HeaderMenuGiftBox className={CyClass('cy-header-menu-gift-button')}>
                            {_renderGiftIndicator()}
                            <HeaderMenuIconBox src={services.theme.currentTheme.assets.images.mini_orbit.header_icons.gift_png.toString()} onClick={services.miniOrbit.openFreePlays} />
                        </HeaderMenuGiftBox>
                        <HeaderMenuIconBox src={services.theme.currentTheme.assets.images.mini_orbit.header_icons.moreMenu_png.toString()} onClick={_openUsefulLinks} className={CyClass('cy-mini-orbit-side-menu-open-button')} />
                    </HeaderMenuIconsBox>
                </MiniOrbitNavbarWrapperBox>
            </MiniOrbitHeaderBox>
        </React.Fragment>
    )
})

export const MiniOrbitHeaderComponent = withServices(ComponentBody, ['header']);